var App = App || {};

App.ComponentCardPromos = (function ($) {
    'use strict';

    function Carousel() {

        $(".component-card-promos.carousel").each(function () {

            const carousel = $(this).find(".splide");

            var splide = new Splide(carousel[0], {
                type: 'loop',
                speed: 500,
                focus:'center',
                mediaQuery: 'min',
                breakpoints: {
                    768: {
                        padding: '30%',
                    },
                }
            });

            splide.on('mounted', function () {
                $(splide.root).parents(".component-card-promos-items");
                CarouselTransition(splide, splide.index);
            });

            splide.on('move', function (newIndex) {
                CarouselTransition(splide, newIndex);
            });

            splide.mount({});
        });
    }

    function CarouselTransition(splide, index) {
        $(splide.Components.Slides.getAt(index).slide).addClass("zag-active").siblings().removeClass("zag-active");
        $(splide.Components.Slides.getAt(index - 1).slide).addClass("zag-prev").siblings().removeClass("zag-prev");
        $(splide.Components.Slides.getAt(index + 1).slide).addClass("zag-next").siblings().removeClass("zag-next");
    }

    return {
        Carousel: Carousel
    };

})(jQuery);

$(function () {
    App.ComponentCardPromos.Carousel();
});